import { render, staticRenderFns } from "./letterCommitment.vue?vue&type=template&id=985dccba&scoped=true"
import script from "./letterCommitment.vue?vue&type=script&lang=js"
export * from "./letterCommitment.vue?vue&type=script&lang=js"
import style0 from "./letterCommitment.vue?vue&type=style&index=0&id=985dccba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985dccba",
  null
  
)

export default component.exports